module.exports = __webpack_public_path__ + "img/Guide.c81db41d.png";